import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetHealthVerifySpecialties,
	GetHealthVerifySpecialtiesModel,
	GetHealthVerifySpecialtiesParams,
} from 'domain/usecases/private/booking-flow/health/get-health-verify-specialties';

export class RemoteGetVerifySpecialties implements GetHealthVerifySpecialties {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthVerifySpecialtiesModel>,
	) {}

	async get({
		signal,
		...params
	}: GetHealthVerifySpecialtiesParams): Promise<GetHealthVerifySpecialtiesModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
